import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { getLoadedActions } from '../../helpers/applications';
import { postJson } from '../../helpers/RequestsHelper';

class BlockTest extends Component {

    state = {
        error: false,
        loading: false,
        tested: false
    }

    constructor() {
        super()
        this.loadJson = this.loadJson.bind(this)
    }


    async loadJson() {
        let error
        try {
            this.setState(({ error: false, loading: true, tested: false }))
            const block = {
                application: this.props.block.application,
                params: this.props.block.params,
                action: { id: this.props.block.action.id }
            }
            const result = await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/" + this.props.block.application + "/test", block)
            if (!result.error) {
                this.setState(({ error: false, loading: false, tested: true }))
                this.props.onTested(true)
                return
            } else {
                error = this.createTextLinks(result.error)
            }
        } catch {
        }
        if (error === "fail") {
            error = this.props.t("lbl_error")
        }
        this.setState(({ error, loading: false, tested: true }))
        this.props.onTested(false)
    }

    createTextLinks(text) {
        const re = new RegExp("(((https?\:\/\/)|(www\.))[^\) ]*)", "gi")
        const match = re.exec(text)
        if (match) {
            const url = match[0]
            const index = text.indexOf(url)
            return <>{text.substring(0, index)}<a href={url} target="_blank" rel="noopener noreferrer">{url}</a>{text.substring(index + url.length)}</>
        } else {
            return text
        }
        // return (text || "").replace(
        //   /(((https?\:\/\/)|(www\.))[^\) ]*)/gi,
        //   function(match){
        //         return <a href="' + match + '"> {match}</a>
        //   }
        // );
    };

    render() {
        const { t } = this.props;

        let emptyRequiredFields = []
        const block = this.props.block
        const action = block.action
        if (action && action.types) {
            action.types.forEach(type => {
                if (action.steps.find(a => a.fields === type.id)) {
                    type.fields.forEach(field => {
                        if (field.required) {
                            if (!block.params
                                || !block.params.fields
                                || !block.params.fields[field.id]
                                || block.params.fields[field.id].trim() === "") {
                                emptyRequiredFields.push(field)
                            }
                        }
                    })
                }
            });
        }
        if (action && action.steps) {
            action.steps.forEach(step => {
                if (step.required) {
                    if (!block.params
                        || !block.params[step.id]
                        || block.params[step.id].trim && block.params[step.id].trim() === "") {
                        emptyRequiredFields.push(step)
                    }
                }
                if (step.fields) {
                    var fields = step.fields
                    if ("string" === typeof step.fields) {
                        const actions = getLoadedActions(block.application)
                        fields = actions.types[step.fields].fields
                    }
                    fields.forEach(field => {
                        if (field.required &&
                            (!block.params
                                || !block.params[step.id]
                                || !block.params[step.id][field.id]
                                || block.params[step.id][field.id].trim && block.params[step.id][field.id].trim() === "")) {

                            emptyRequiredFields.push(field)
                        }
                    })
                }
            });
        }

        const error = emptyRequiredFields.length > 0 ?
            " " + t("lbl_required") + " " + emptyRequiredFields.filter(a => a && a.name && a.name !== "").map(a => a.name).join(', ') :
            this.state.error ? this.state.error : undefined

        const test = this.state.loading ?
            <div className="spinner-border" role="status">
                <span className="sr-only">{t("loading")}</span>
            </div>
            :
            <button id="testbtn" onClick={this.loadJson} className={this.props.block.tested ? "submit-btn-2" : "submit-btn"}
                disabled={emptyRequiredFields.length > 0} title={t("lbl_test")}
            >{t("btn_test")}</button>

        return <div>{test}&nbsp;
        {this.state.tested ? (error ? <span className="text-danger">{error}</span> :
                <span className="text-success">{t("lbl_success")}</span>) : ""}
        </div>
    }
}

export default withTranslation()(BlockTest)